import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Modal from './model'
import styled from 'styled-components';
import {
  AssessRail, Acard, Tag, TagDot, Seg, RowBetween, Card, Btn,
} from '../ui/primitives';

export const Dbody = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export const AssessmentHeading = styled.h2`
  color: ${({ theme }) => theme.text};
  font-family: ${({ theme }) => theme.fontHead};
  font-size: 16px;
  font-weight: 700;
  margin: 0;
`;

export const SubText = styled.p`
  margin: 2px 0 0;
  font-size: ${({ theme }) => theme.fsSm};
  color: ${({ theme }) => theme.textMuted};
`;

export const DropdownContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Dropdown = styled.select`
  height: ${({ theme }) => theme.controlH};
  padding: 0 13px;
  font-size: 13px;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.rMd};
  width: 180px;
  background-color: ${({ theme }) => theme.surface2};
  color: ${({ theme }) => theme.text};
  outline: none;
`;

export const DashboardContainer = styled.div`
  margin-top: ${({ theme }) => theme.gap};
  position: relative;
  width: 100%;
`;

export const ScrollContainer = styled.div`
  width: 100%;
  padding-bottom: 0;
`;

export const EmptyCard = styled(Card)`
  grid-column: 1 / -1;
  text-align: center;
  padding: ${({ theme }) => theme.padCard};
  color: ${({ theme }) => theme.textMuted};
`;

export const DetailLabel = styled.span`
  font-size: ${({ theme }) => theme.fsMicro};
  font-weight: 650;
  color: ${({ theme }) => theme.textMuted};
`;

const Dashboard = ({ userplan }) => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filter, setFilter] = useState('current'); // Default to 'current'
    const [selectedButton, setSelectedButton] = useState('current'); // Default to 'current'
    const [selectedCourse, setSelectedCourse] = useState(''); // Default to empty string
    const [courseDataCounts, setCourseDataCounts] = useState({}); // To store counts for each filter type
    const dataContainerRef = useRef(null);
    const [earningPaidAmount, setEarningPaidAmount] = useState(null);
    const [assessmentsCount, setAssessmentsCount] = useState(0);
    const [studentsCount, setStudentsCount] = useState(0);
    const [courseCount, setCourseCount] = useState(0);
    const [courses, setCourses] = useState([]);
    const [selectedAssessment, setSelectedAssessment] = useState(null); // State for selected assessment
    const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
    const userId = localStorage.getItem("userId");
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiUrl1 = process.env.REACT_APP_API_URL1;

    const getBasicAuthHeader = () => {
        const username = process.env.REACT_APP_API_USERNAME;
        const password = process.env.REACT_APP_API_PASSWORD;
        const encodedCredentials = btoa(`${username}:${password}`);
        return `Basic ${encodedCredentials}`;
      };

    useEffect(() => {
        fetchData();
        //fetchEarningPaidAmount();
        fetchData1();
    }, []);

    useEffect(() => {
        filterData(filter);
    }, [filter, data, selectedCourse]);

    useEffect(() => {
        updateDataCounts();
    }, [data, selectedCourse]);

    const fetchData = async () => {
        const body = { user_id: userId };
        const token = localStorage.getItem('token');
        try {
            const responseAssessments = await axios.post(apiUrl1 + `/api/get_tests_for_instructor_id`, body, {
                headers: {
                    'Content-Type': "application/json",
                    "Accept": "*/*",
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': token,
          "X-Api-Version": 'v2'
                }
            });
            setData(responseAssessments.data.data);
            setAssessmentsCount(responseAssessments.data.data.length);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const formatDate = (timestamp) => {
        const date = new Date(parseInt(timestamp));
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const filterData = (filterType) => {
        let filtered;
        const currentDate = new Date();

        if (!selectedCourse) {
            filtered = data.filter(item => {
                if (filterType === 'past') {
                    return new Date(parseInt(item.end_date)) < currentDate;
                } else if (filterType === 'current') {
                    return new Date(parseInt(item.start_date)) <= currentDate && new Date(parseInt(item.end_date)) >= currentDate;
                } else if (filterType === 'pending') {
                    return new Date(parseInt(item.start_date)) > currentDate;
                }
                return true;
            });
        } else {
            filtered = data.filter(item => item['course_name'] === selectedCourse);
            if (filterType === 'past') {
                filtered = filtered.filter(item => new Date(parseInt(item.end_date)) < currentDate);
            } else if (filterType === 'current') {
                filtered = filtered.filter(item => new Date(parseInt(item.start_date)) <= currentDate && new Date(parseInt(item.end_date)) >= currentDate);
            } else if (filterType === 'pending') {
                filtered = filtered.filter(item => new Date(parseInt(item.start_date)) > currentDate);
            }
        }

        setFilteredData(filtered);
        setSelectedButton(filterType);
    };

    const updateDataCounts = () => {
        const currentDate = new Date();
        let filteredData = data;

        if (selectedCourse) {
            filteredData = data.filter(item => item['course_name'] === selectedCourse);
        }

        const pastCount = filteredData.filter(item => new Date(parseInt(item.end_date)) < currentDate).length;
        const currentCount = filteredData.filter(item => new Date(parseInt(item.start_date)) <= currentDate && new Date(parseInt(item.end_date)) >= currentDate).length;
        const pendingCount = filteredData.filter(item => new Date(parseInt(item.start_date)) > currentDate).length;

        setCourseDataCounts({
            past: pastCount,
            current: currentCount,
            pending: pendingCount
        });
    };

    const fetchData1 = async () => {
        try {
            const responseCourses = await axios.get(apiUrl + `/api/course/${userId}`, {
                headers: {
                   'Content-Type': "application/json",
        "Accept": "*/*",
        "Access-Control-Allow-Origin": "*",
        'Authorization': getBasicAuthHeader(),
                }
            });
            setCourseCount(responseCourses.data.length);
            setCourses(responseCourses.data);

            const responseStudents = await axios.get(apiUrl + `/api/studentcourses/${userId}`, {
                headers: {
                    'Content-Type': "application/json",
                    "Accept": "*/*",
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': getBasicAuthHeader(),
                }
            });
            setStudentsCount(responseStudents.data.length);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleDetailsClick = (item) => {
        setSelectedAssessment(item);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedAssessment(null);
    };

    return (
        <>
             <Dbody>
      <RowBetween style={{ marginBottom: "10px" }}>
        <div>
          <AssessmentHeading>Today's assessments</AssessmentHeading>
          <SubText>Live, upcoming and completed across your courses</SubText>
        </div>
        <DropdownContainer>
          <Dropdown value={selectedCourse} onChange={(e) => setSelectedCourse(e.target.value)}>
            <option value="">Select Course</option>
            {courses.map(course => (
              <option key={course.courseId} value={course.courseName}>{course.courseName}</option>
            ))}
          </Dropdown>
        </DropdownContainer>
      </RowBetween>

      <DashboardContainer>
        <Seg>
          <button className={selectedButton === 'past' ? 'is-on' : ''} onClick={() => setFilter('past')}>
            Past ({courseDataCounts.past || 0})
          </button>
          <button className={selectedButton === 'current' ? 'is-on' : ''} onClick={() => setFilter('current')}>
            Current ({courseDataCounts.current || 0})
          </button>
          <button className={selectedButton === 'pending' ? 'is-on' : ''} onClick={() => setFilter('pending')}>
            Pending ({courseDataCounts.pending || 0})
          </button>
        </Seg>

        <ScrollContainer>
        <AssessRail ref={dataContainerRef} style={{ marginTop: "10px" }}>
  {filteredData.length === 0 && (
    <EmptyCard $pad>No assessments in this bucket.</EmptyCard>
  )}
  {filteredData.map((item, index) => {
    const status = selectedButton;
    return (
      <Acard key={index} onClick={() => handleDetailsClick(item)}>
        <div className="acard__top">
          <span className="acard__course">{item.course_name || "Assessment"}</span>
          <Tag $tone={status === "current" ? "green" : status === "pending" ? "amber" : "gray"}>
            <TagDot />
            {status === "current" ? "Live" : status === "pending" ? "Upcoming" : "Closed"}
          </Tag>
        </div>
        <div className="acard__name">{item.name}</div>
        <div className="acard__meta">
          <div>Start<b>{formatDate(item.start_date)}</b></div>
          <div>End<b>{formatDate(item.end_date)}</b></div>
        </div>
        <div className="acard__foot">
          <DetailLabel>Details</DetailLabel>
          <Btn $sm onClick={(event) => { event.stopPropagation(); handleDetailsClick(item); }}>View Details</Btn>
        </div>
      </Acard>
    );
  })}
</AssessRail>
        </ScrollContainer>
      </DashboardContainer>

      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={closeModal} assessment={selectedAssessment} />
      )}
    </Dbody>
    </>
  );
};

export default Dashboard;
